<template>
  <v-autocomplete
    id="temas-select"
    v-model="value.municipioId"
    :items="values"
    :label="
      isParceiro
        ? 'Parceiros'
        : isSala
        ? 'Salas'
        : isGov
        ? 'Projetos'
        : 'Municípios'
    "
    placeholder="Selecione..."
    v-on:change="
      (e) => {
        $emit('onChange', value);
        $emit(
          'nameChange',
          allValues
            .filter((val) => value.municipioId.includes(val.municipioId))
            .map((item) => item.nome)
        );
      }
    "
    :disabled="disabled"
    :clearable="clearable"
    :multiple="multiple"
    item-value="municipioId"
    item-text="nome"
    :rules="rules"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ value.municipioId.length - maxDisplay }}
        {{
          isParceiro
            ? "Parceiros"
            : isSala
            ? "Salas"
            : isGov
            ? "Projetos"
            : "Municípios"
        }})</span
      >
    </template>
    <template slot="no-data"> Nenhum Município retornado </template>
  </v-autocomplete>
</template>

<script>
import { cityAPI } from "@/modules/city";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ComboboxMunicipioTerritorio",
  computed: {
    ...mapGetters(["isSala", "isParceiro", "isGov"]),
  },
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    clearable: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: { type: Array | Object },
    filterByTerritorios: { type: Number },
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadCities() {
      this.setLoading(true);
      cityAPI
        .list()
        .then((resp) => {
          this.values = resp.data;
          this.allValues = resp.data;
          this.setLoading(false);
        })
        .catch((e) => {
          console.log("error on comboboxMunicipioTerritorio: ", e);
          this.$notification.error("Error ao buscar municípios");
          this.setLoading(false);
        });
    },
  },
  mounted() {
    this.loadCities();
  },

  data() {
    return {
      values: [],
      allValues: [],
      maxDisplay: 1,
    };
  },
};
</script>
